
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import tick from "../../../assets/img/tick Credits Added.svg";
import "../../../assets/sass/payment-success.scss";
import add_credit from "../../../assets/img/blue Credits Added.svg";
import { hitCheckStatusForServiceAreaSubAfterTryAgainApi, clearCheckStatusForServiceAreaSubAfterTryAgainData } from "../../../Redux/Professional/CheckStatusForServiceAreaSubAfterTryAgainSlice";


const ServiceAreaSubTryAginPayment = () => {
  const dispatch = useDispatch();
  const { customerId } = useParams();
  const { data, isLoading } = useSelector(
    (state) => state.checkStatusForServiceAreaSubAfterTryAgainReducer
  );

  useEffect(() => {
    if (customerId) {
      dispatch(hitCheckStatusForServiceAreaSubAfterTryAgainApi(customerId));
    }
  }, [dispatch, customerId]);

  if (isLoading) {
    return (
      <div className="payment-success-fullscreen">
        <div className="payment-success-card">Checking payment status...</div>
      </div>
    );
  }

  if (data && data.status === true) {
    return (
      <div className="payment-success-fullscreen">
        <div className="payment-success-card">
          <img src={tick} alt="Success" className="payment-success-icon" />
          <div className="payment-success-title">Payment Issue Resolved!</div>
          <div className="payment-success-message">
            Your payment issue has been resolved.<br />
            You can now go back to the application and use all subscription features.<br />
            Thank you for your patience!
          </div>
        </div>
      </div>
    );
  }

  if (data && data.status === false) {
    return (
      <div className="payment-success-fullscreen">
        <div className="payment-success-card">
          <img src={add_credit} alt="Try Again" className="payment-success-icon" />
          <div className="payment-success-title" style={{ color: '#dc2626' }}>Payment Not Sorted</div>
          <div className="payment-success-message">
            Your payment issue is not resolved yet.<br />
            Please try again to complete your payment and unlock subscription features.
          </div>

        </div>
      </div>
    );
  }

};

export default ServiceAreaSubTryAginPayment;
